import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  QueryParams,
  PagedResponse,
  Model,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";

export class ExpertsService extends BaseRemoteService {
  public async search(params: QueryParams, opts: Opts) {
    const url = `${this.apiRoot}/experts/${paramsToSearchString(params)}`;
    const response = await super.getRequest<PagedResponse<Model>>(url, opts);
    const mappedResponse: PagedResponse<Model> = {
      ...response,
      data: response.data.map(e => this.mapModelToLookup(e)),
    };
    return mappedResponse;
  }

  public async get(id: string, opts: Opts) {
    const url = `${this.apiRoot}/expertApplyById?id=${id}`;
    const response = await super.getRequest<Model>(url, opts);
    return this.mapModelToLookup(response);
  }

  private mapModelToLookup(expert: Model): Model {
    const mappedLabel = `${expert.referenceNumber} - ${expert.personalDetails.fullName}`;
    return {
      name: mappedLabel,
      label: mappedLabel,
      id: expert.id
    }
  }
}